import { Locale, K } from "../constants";

const locale: Locale = {
  [K.COPY_TOOLTIP]: "复制",
  [K.EXPORT_TOOLTIP]: "下载",
};

export default locale;
